// extracted by mini-css-extract-plugin
module.exports =  {"content":"content--Mg66r","text":"text--JzHjN"};